import { render, staticRenderFns } from "./MaterialsExportList.vue?vue&type=template&id=4130c68c&scoped=true"
import script from "./MaterialsExportList.vue?vue&type=script&lang=js"
export * from "./MaterialsExportList.vue?vue&type=script&lang=js"
import style0 from "./MaterialsExportList.vue?vue&type=style&index=0&id=4130c68c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4130c68c",
  null
  
)

export default component.exports